import type { MentorProfile } from '#shared/types/User'

import { CompletenessWeight, useCompleteness } from '@/composables/useCompleteness'
import { isRequired, validate } from 'last-validator'
import { isMinLength } from '@/validators/isMinLength'

export function validateMentorProfile(mentorProfile: MentorProfile) {
    return validate<MentorProfile>(mentorProfile, {
        motivation: [isMinLength(250)],
        interests: [isRequired()]
    })
}

export function checkMentorProfileComplete(mentorProfile: MentorProfile) {
    const { evaluate } = useCompleteness()

    return evaluate(mentorProfile, {
        interests: {
            mandatory: true,
            weight: CompletenessWeight.MAX
        },
        who: {
            weight: CompletenessWeight.LOW
        },
        how: {
            weight: CompletenessWeight.MID
        }
    })
}
